const REQUEST_COURSE_OPTIONS_FAIL = 'REQUEST_COURSE_OPTIONS_FAIL';
const REQUEST_COURSE_OPTIONS_SUCCESS = 'REQUEST_COURSE_OPTIONS_SUCCESS';
const REQUEST_COURSE_OPTIONS = 'REQUEST_COURSE_OPTIONS';

export {
  REQUEST_COURSE_OPTIONS_FAIL,
  REQUEST_COURSE_OPTIONS_SUCCESS,
  REQUEST_COURSE_OPTIONS,
};
